import React from 'react';
import {
    BoxProps,
    useTheme,
    useMediaQuery,
    TypographyProps,
    Box,
    Typography,
} from '@material-ui/core';

type PageHeaderTitleProps = BoxProps & {
    title: string;
    subtitle?: string;
    centered?: boolean;
};

const PageHeaderTitle = ({ title, subtitle, centered = true, ...props }: PageHeaderTitleProps) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const titleProps: TypographyProps = { style: {} };

    if (matches) {
        titleProps.variant = 'h4';

        if (!centered && !matches) {
            titleProps.style.marginLeft = `${theme.spacing(2)}px`;
        }
    }

    if (!matches) {
        if (subtitle) {
            titleProps.variant = 'body1';
            titleProps.style.lineHeight = '1rem';
        } else {
            titleProps.variant = 'subtitle2';
        }
    }

    return (
        <Box {...props}>
            <Typography align={centered ? 'center' : 'left'} {...titleProps}>
                {title}
            </Typography>
            {subtitle && (
                <Typography
                    noWrap
                    color="textSecondary"
                    align={centered ? 'center' : 'left'}
                    variant={matches ? 'body1' : 'body2'}
                    style={{ lineHeight: matches ? 'inherit' : '1rem' }}
                >
                    {subtitle}
                </Typography>
            )}
        </Box>
    );
};

export default PageHeaderTitle;
